import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import { Routes } from "../../constants";
import { Circles } from "react-loader-spinner";
import Swal from "sweetalert2";
import { AdminService } from "../../services";
 
const GPAppointments = (props) => {
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [bookingStatus, setBookingStatus] = useState({});
  const user_id = localStorage.getItem("user_id");
  const history = useHistory();
 
  const handleGoBack = () => {
    history.push(Routes.SERVICE_SELECTION);
  };
 
  const getPatientList = async () => {
    const response = await AdminService.getPatientList(user_id);
    setPatientList(response.message);
  };
 
  const fetchUpcomingAppointments = async () => {
    const response = await props.auth.getUpcomingBookingDetails(user_id);
    setListData(response.data.upcoming);
  };
 
  const getBookingDetails = async () => {
    const response = await AdminService.getBookingDetails(user_id);
    if (response) setBookingStatus(response.data.bookingStatus);
  };
 
  const handleCancel = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to Cancel this Appointment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (result.isConfirmed) {
      setLoading(true);
      const response = await AdminService.CancelAppointment(user_id, id);
      if (response) window.location.reload();
    }
  };
 
  useEffect(() => {
    setLoading(true);
    Promise.all([
      getPatientList(),
      fetchUpcomingAppointments(),
      getBookingDetails(),
    ]).finally(() => setLoading(false));
  }, []);
 
  return (
    <>
      {loading && (
        <div className="spinner">
          <div className="loader">
            <Circles
              height="110"
              width="110"
              color="#FFF"
              ariaLabel="loading"
            />
          </div>
        </div>
      )}
 
      <section className="stre-appo">
        <div className="container">
          <button className="back-button me-3" onClick={handleGoBack}>
            <i className="fas fa-arrow-left"></i>
          </button>
          {/* Booking CTA */}
          <div className="appoitment-box bl align-items-center brdr-none mb-4">
            <div className="appb-content well">
              <div className="row align-items-center">
                <div className="col-md-7">
                  <p className="m-6">
                    Click below to arrange your GP phone or video appointment at
                    a convenient time.
                  </p>
                </div>
                <div className="col-md-5 text-end">
                  {patientList && patientList.length > 0 ? (
                    <Link
                      to={Routes.PATIENTLIST}
                      className="org-big-btn btn-bx-shadow"
                    >
                      <i className="fa-solid fa-calendar-plus"></i>
                      <span>Book Now</span>
                    </Link>
                  ) : (
                    <Link
                      to={Routes.PATIENTFORM}
                      className="org-big-btn btn-bx-shadow"
                    >
                      <i className="fa-solid fa-calendar-plus"></i>
                      <span>Book Now</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
 
          {/* Upcoming Appointments */}
          <div className="row">
            <div className="col-md-12">
              <h2 className="uph2 mb-4">Upcoming Appointments</h2>
            </div>
 
            <div className="col-lg-10">
              <div
                className={
                  listData && listData.length > 2
                    ? "upc-appt scroll-bx"
                    : "upc-appt"
                }
              >
                {listData && listData.length > 0 ? (
                  listData.map((item, index) => {
                    const date = new Date(item.appointment_time);
                    const month = date.toLocaleString("en-US", {
                      month: "long",
                      timeZone: "Europe/London",
                    });
                    const day = date.toLocaleString("en-US", {
                      day: "numeric",
                      timeZone: "Europe/London",
                    });
                    const time = date.toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                    });
                    return (
                      <div
                        key={index}
                        className="card n-card brdr-blck-left mb-3"
                      >
                        <div className="upc-sec">
                          <div className="upc-date">
                            <span>{month}</span>
                            <h3>{day}</h3>
                            <strong>{time}</strong>
                          </div>
                          <div className="upc-specialist">
                            <div className="upc-detail">
                              <h4>General Practitioner</h4>
                              <p>{item.reason_for_booking || "_"}</p>
                            </div>
                            <div className="upc-type ps-4">
                              <strong>{item.consultation_type}</strong>
                              <button
                                onClick={() => handleCancel(item.id)}
                                className="dark-btn mt-2"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="card n-card brdr-blue-left mb-3">
                    <label>You Have No Upcoming Appointment</label>
                  </div>
                )}
              </div>
            </div>
 
            {/* Booking Stats */}
            <div className="col-md-2 apt-booking">
              <div className="card n-card brdr-blue-bottom mb-4">
                <div className="booked-appt mb-2">
                  <i className="fa-regular fa-calendar-check"></i>
                  <div className="bk-appt-text">
                    <h2>{bookingStatus.booked}</h2>
                  </div>
                </div>
                <p>
                  <small>Appointment Booked</small>
                </p>
              </div>
              <div className="card n-card brdr-blue-bottombl mb-4">
                <div className="booked-appt bl mb-2">
                  <i className="fa-regular fa-calendar-xmark" />
                  <div className="bk-appt-text">
                    <h2>{bookingStatus.cancelled}</h2>
                  </div>
                </div>
                <p>
                  <small>Appointment Canceled</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
 
export default injectModels(["auth"])(GPAppointments);